export function ErrorWhoScored({ baseUrl }: { baseUrl: string }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        fontFamily: "'Lato', sans-serif",
        margin: 0,
        padding: 0,
      }}
    >
      {/* Header spacer */}
      <div
        style={{
          height: '60px',
          width: '100%',
        }}
      />

      {/* Content */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 20px',
        }}
      >
        <div
          style={{
            backgroundColor: '#ffffff',
            padding: '40px 60px',
            maxWidth: '600px',
          }}
        >
          <p
            style={{
              fontSize: '18px',
              textAlign: 'center',
              margin: 0,
              lineHeight: 1.6,
              color: '#000000',
            }}
          >
            The page you requested does not exist in{' '}
            <a
              href={baseUrl || 'https://www.whoscored.com'}
              style={{
                color: '#5680c1',
                textDecoration: 'underline',
                fontFamily: 'inherit',
                fontSize: 'inherit',
                fontWeight: 'normal',
                padding: 0,
                margin: 0,
                border: 'none',
                background: 'none',
                display: 'inline',
              }}
            >
              WhoScored.com
            </a>
          </p>
        </div>
      </div>

      {/* Footer spacer */}
      <div
        style={{
          height: '60px',
          width: '100%',
        }}
      />
    </div>
  );
}
